module.exports = __webpack_public_path__ + "static/media/MockPhone11.ab40df17.png";